import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { createStore, useStore } from "zustand";
const BrandContext = /*#__PURE__*/ createContext(null);
const toStaticBrand = (brand)=>{
    const { isSubscribed , subscriberCount , hasNewNotice , ...staticBrand } = brand;
    return staticBrand;
};
export const BrandProvider = (param)=>{
    let { children , initialValues  } = param;
    const [store] = useState(()=>{
        return createStore((set)=>({
                brand: toStaticBrand(initialValues),
                updateBrand: (brand)=>set({
                        brand: toStaticBrand(brand)
                    })
            }));
    });
    return /*#__PURE__*/ _jsx(BrandContext.Provider, {
        value: store,
        children: children
    });
};
export const useBrandStore = (selector)=>{
    const store = useContext(BrandContext);
    if (!store) {
        throw new Error("Missing BrandProvider");
    }
    return useStore(store, selector);
};
